import React from "react";
import { LegacyEmailComponentType } from "./EmailComponents.type";

export const SupplierDeclinedEmailContent: React.FC<
	LegacyEmailComponentType
> = ({ projectTitle, rfqTitle, additionalMessage, companyName }) => {
	return (
		<div>
			<svg
				width="664"
				height="224"
				viewBox="0 0 664 224"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clip-path="url(#clip0_57_24)">
					<path
						d="M0 16C0 7.16345 7.16344 0 16 0H648C656.837 0 664 7.16344 664 16V224H0V16Z"
						fill="#003CE9"
					/>
					<path
						d="M667.718 -241C680.248 -161.57 663.646 15.6318 497 89"
						stroke="#708FFB"
						stroke-width="1.5"
					/>
					<circle
						cx="497"
						cy="89"
						r="7"
						fill="#4864F9"
					/>
					<path
						d="M326 66L338 78M338 66L326 78M323.6 90H340.4C343.76 90 345.44 90 346.724 89.346C347.853 88.7708 348.771 87.8529 349.346 86.7239C350 85.4405 350 83.7603 350 80.4V63.6C350 60.2397 350 58.5595 349.346 57.2761C348.771 56.1471 347.853 55.2292 346.724 54.654C345.44 54 343.76 54 340.4 54H323.6C320.24 54 318.56 54 317.276 54.654C316.147 55.2292 315.229 56.1471 314.654 57.2761C314 58.5595 314 60.2397 314 63.6V80.4C314 83.7603 314 85.4405 314.654 86.7239C315.229 87.8529 316.147 88.7708 317.276 89.346C318.56 90 320.24 90 323.6 90Z"
						stroke="#DEEBFF"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M168.808 164V118.4H182.128L185.728 122V140.96L182.548 144.14L186.148 164H180.568L177.028 144.56H174.568V164H168.808ZM178.768 139.88L179.968 138.68V124.4L178.768 123.2H174.568V139.88H178.768ZM202.624 118.4V123.32H194.344V138.98H201.784V143.9H194.344V164H188.584V118.4H202.624ZM215.122 140.78L221.902 164H216.142L212.122 149.24L208.282 164H202.762L209.542 140.78L203.062 118.4H208.822L212.482 132.68L216.082 118.4H221.602L215.122 140.78ZM231.098 164V118.4H244.418L248.018 122V140.96L244.838 144.14L248.438 164H242.858L239.318 144.56H236.858V164H231.098ZM241.058 139.88L242.258 138.68V124.4L241.058 123.2H236.858V139.88H241.058ZM250.874 164V118.4H265.094V123.32H256.634V138.44H264.014V143.36H256.634V159.08H265.214V164H250.874ZM284.056 122V160.4L280.456 164H278.056V169.28H272.896V164H270.496L266.896 160.4V122L270.496 118.4H280.456L284.056 122ZM277.096 123.56H273.856L272.656 124.76V157.64L273.856 158.84H277.096L278.296 157.64V124.76L277.096 123.56ZM303.419 160.4L299.819 164H290.159L286.559 160.4V118.4H292.319V157.88L293.519 159.08H296.459L297.659 157.88V118.4H303.419V160.4ZM306.102 164V118.4H320.322V123.32H311.862V138.44H319.242V143.36H311.862V159.08H320.442V164H306.102ZM331.793 131.6V124.4L330.593 123.2H328.493L327.293 124.4V137.24L328.493 138.44H334.133L337.733 142.04V160.4L334.133 164H325.013L321.413 160.4V150.86H327.173V158L328.373 159.2H330.773L331.973 158V144.56L330.773 143.36H325.133L321.533 139.76V122L325.133 118.4H333.953L337.553 122V131.6H331.793ZM354.977 123.2H349.517V164H343.757V123.2H338.297V118.4H354.977V123.2ZM377.615 118.4L381.215 122V160.4L377.615 164H364.115V118.4H377.615ZM374.255 159.08L375.455 157.88V124.52L374.255 123.32H369.875V159.08H374.255ZM383.774 164V118.4H397.994V123.32H389.534V138.44H396.914V143.36H389.534V159.08H398.114V164H383.774ZM399.796 160.4V122L403.396 118.4H412.276L415.876 122V132.26H410.116V124.4L408.916 123.2H406.756L405.556 124.4V157.88L406.756 159.08H408.916L410.116 157.88V150.08H415.876V160.4L412.276 164H403.396L399.796 160.4ZM431.375 164H417.995V118.4H423.755V159.08H431.375V164ZM432.733 164V118.4H438.493V164H432.733ZM441.259 164V118.4H447.499L454.099 150.02V118.4H459.319V164H453.079L446.479 132.86V164H441.259ZM462.091 164V118.4H476.311V123.32H467.851V138.44H475.231V143.36H467.851V159.08H476.431V164H462.091ZM491.793 118.4L495.393 122V160.4L491.793 164H478.293V118.4H491.793ZM488.433 159.08L489.633 157.88V124.52L488.433 123.32H484.053V159.08H488.433Z"
						fill="white"
					/>
					<path
						d="M-82 31L80 194"
						stroke="#708FFB"
						stroke-width="1.5"
					/>
					<circle
						cx="80"
						cy="194"
						r="7"
						fill="#4864F9"
					/>
				</g>
				<defs>
					<clipPath id="clip0_57_24">
						<path
							d="M0 16C0 7.16345 7.16344 0 16 0H648C656.837 0 664 7.16344 664 16V224H0V16Z"
							fill="white"
						/>
					</clipPath>
				</defs>
			</svg>

			<div className="my-10">
				<p className="py-5">Dear {companyName || "Participant's"},</p>
				<div className="space-y-3">
					<p>
						Thank you for your time and effort in submitting your response for
						the RFx regarding {projectTitle}.
					</p>
					<p>
						After careful consideration, we regret to inform you that your
						submission was not selected for this particular project.
					</p>
					<p>
						The reasons for this decision is:
						<br />
						{additionalMessage || ""}
					</p>
					<p>We appreciate your understanding.</p>
					<p>
						We value your participation and encourage you to consider future{" "}
						{rfqTitle} opportunities with us.
					</p>
					<p>Thank you once again for your submission.</p>
				</div>
			</div>
		</div>
	);
};
